import { clearAuthToken, getAuthToken } from '../utils/authToken';

let isRedirectingToLogin = false;

/**
 * Clear stored token and send the user to login when the API reports an expired/invalid session.
 * Backend expiry is the source of truth — this only reacts to 401 responses.
 */
export function handleUnauthorized() {
	clearAuthToken();
	window.dispatchEvent(new CustomEvent('auth:unauthorized'));

	if (isRedirectingToLogin) {
		return;
	}

	const path = window.location.pathname;
	if (path === '/' || path === '') {
		return;
	}

	isRedirectingToLogin = true;
	window.location.assign('/');
}

/**
 * Authenticated fetch wrapper used by apiService.
 * Attaches the bearer token and redirects to login on 401.
 */
export async function apiFetch(url, options = {}) {
	const headers = new Headers(options.headers || {});

	if (!headers.has('Accept')) {
		headers.set('Accept', 'application/json');
	}

	if (!headers.has('Authorization')) {
		const token = getAuthToken();
		if (token) {
			headers.set('Authorization', `Bearer ${token}`);
		}
	}

	const response = await fetch(url, {
		...options,
		headers,
	});

	if (response.status === 401) {
		handleUnauthorized();
		throw new Error('Session expired');
	}

	return response;
}
